module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('seo-title', {
    attrs: {
      "content": _vm.$t('technology.meta.title')
    }
  }), _vm._v(" "), _c('seo-description', {
    attrs: {
      "content": _vm.$t('technology.meta.description')
    }
  }), _vm._v(" "), _c('seo-author', {
    attrs: {
      "content": "Deveo ApS"
    }
  }), _vm._v(" "), _c('seo-og-title', {
    attrs: {
      "content": _vm.$t('technology.meta.title')
    }
  }), _vm._v(" "), _c('seo-og-description', {
    attrs: {
      "content": _vm.$t('technology.meta.description')
    }
  }), _vm._v(" "), _c('seo-og-image', {
    attrs: {
      "content": "/static/images/opengraph/fb_og.png"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "bg-deveo-grey-gradient no-p-b",
    staticStyle: {
      "overflow": "hidden",
      "padding-top": "15vh",
      "margin-top": "-105px"
    }
  }, [_c('div', {
    staticClass: "tech-container"
  }, [_c('tech-bubble', {
    attrs: {
      "icon": "amazons3",
      "size": "large"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "babel",
      "size": "small"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "bootstrap",
      "size": "medium"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "css3",
      "size": "small"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "docker",
      "size": "large"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "git",
      "size": "medium"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "github",
      "size": "large"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "html5",
      "size": "small"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "javascript",
      "size": "medium"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "jquery",
      "size": "small"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "laravel",
      "size": "large"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "less",
      "size": "small"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "mysql",
      "size": "medium"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "nginx",
      "size": "medium"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "nodejs",
      "size": "large"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "phpstorm",
      "size": "small"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "redis",
      "size": "large"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "sass",
      "size": "small"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "react",
      "size": "small"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "ssh",
      "size": "medium"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "vue",
      "size": "large"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "webpack",
      "size": "medium"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "wordpress",
      "size": "large"
    }
  })], 1), _vm._v(" "), _c('img', {
    staticClass: "arch",
    attrs: {
      "src": "/static/images/layout/arch.svg",
      "alt": "Arch"
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "bg-deveo-white tech-intro"
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('h2', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('technology.mainHeader')) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "fix-width",
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('technology.mainText')) + "\n            ")])])]), _vm._v(" "), _c('section', {
    staticClass: "bg-deveo-light"
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 terminal-col align-self-center"
  }, [_c('tech-terminal')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-1 col-md-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 col-md-5"
  }, [_c('h4', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('technology.coreFirst')) + " "), _c('span', {
    staticClass: "main-color"
  }, [_vm._v("Core")]), _c('sup', {
    staticClass: "sup-small"
  }, [_vm._v(" by Deveo")]), _vm._v(" "), _c('br'), _vm._v(" " + _vm._s(_vm.$t('technology.coreSecond')) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "divider-md"
  }), _vm._v(" "), _c('div', {
    staticClass: "row small-icons-row",
    attrs: {
      "align": "left"
    }
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('i', {
    staticClass: "ion-ios-bolt"
  }), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('technology.corePointOne')))]), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('technology.corePointOneText')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('i', {
    staticClass: "ion-ios-pulse"
  }), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('technology.corePointTwo')))]), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('technology.corePointTwoText')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('i', {
    staticClass: "ion-ios-locked"
  }), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('technology.corePointThree')))]), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('technology.corePointThreeText')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('i', {
    staticClass: "ion-arrow-graph-up-right main-color"
  }), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('technology.corePointFour')))]), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('technology.corePointFourText')))])])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "bg-deveo-white"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    attrs: {
      "align": "center"
    }
  }, [_c('h2', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('technology.opensourceHeader')) + "\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "fix-width",
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('technology.opensourceTextFirst'))), _c('br'), _vm._v("\n                        " + _vm._s(_vm.$t('technology.opensourceTextSecond')) + " "), _c('b', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v(_vm._s(_vm.totalDownloads))]), _vm._v(" " + _vm._s(_vm.$t('technology.opensourceTextThird')) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "50px"
    }
  })]), _vm._v(" "), _c('tech-package', {
    attrs: {
      "type": "laravel",
      "header": "core",
      "downloads": _vm.packages.core.downloads,
      "stars": _vm.packages.core.stars
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n                        Artistic API framework based on laravel and larapi.\n                    ")])]), _vm._v(" "), _c('tech-package', {
    attrs: {
      "type": "laravel",
      "header": "distributed-generators",
      "downloads": _vm.packages.distributedGenerators.downloads,
      "stars": _vm.packages.distributedGenerators.stars
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n                        Smart generators for distributed laravel. Spin up new bundles in the matter of seconds.\n                    ")])]), _vm._v(" "), _c('tech-package', {
    attrs: {
      "type": "laravel",
      "header": "laravel-api-authenticator",
      "downloads": _vm.packages.laravelApiAuth.downloads,
      "stars": _vm.packages.laravelApiAuth.stars
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n                        API authentication made simple.\n                    ")])]), _vm._v(" "), _c('tech-package', {
    attrs: {
      "type": "laravel",
      "header": "laravel-core-time-tracker",
      "downloads": _vm.packages.laravelCoreTimeTracker.downloads,
      "stars": _vm.packages.laravelCoreTimeTracker.stars
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n                        Advanced and highly precise time tracking of core users.\n                    ")])]), _vm._v(" "), _c('tech-package', {
    attrs: {
      "type": "vue",
      "header": "vue-animate",
      "downloads": _vm.packages.vueAnimate.downloads,
      "stars": _vm.packages.vueAnimate.stars
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n                        An easy way to use beautiful animations on your site. Ideal for hero style landing pages.\n                    ")])]), _vm._v(" "), _c('tech-package', {
    attrs: {
      "type": "vue",
      "header": "vue-error-tracker",
      "downloads": _vm.packages.vueErrorTracker.downloads,
      "stars": _vm.packages.vueErrorTracker.stars
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n                        Vue error tracker keeps track of vue-resource http related errors, and provides an easy solution for tracking errors.\n                    ")])]), _vm._v(" "), _c('tech-package', {
    attrs: {
      "type": "vue",
      "header": "vue-online",
      "downloads": _vm.packages.vueOnline.downloads,
      "stars": _vm.packages.vueOnline.stars
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n                        An easy way to show if a users browser is online with support for custom notification drivers.\n                    ")])]), _vm._v(" "), _c('tech-package', {
    attrs: {
      "type": "vue",
      "header": "vue-seo",
      "downloads": _vm.packages.vueSeo.downloads,
      "stars": _vm.packages.vueSeo.stars
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n                        Easy way to add SEO to any vue based site. Works without jQuery.\n                    ")])]), _vm._v(" "), _c('tech-package', {
    attrs: {
      "type": "vue",
      "header": "vue-toastr",
      "downloads": _vm.packages.vueToastr.downloads,
      "stars": _vm.packages.vueToastr.stars
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n                        A easy-to-use toastr notification plugin developed without jQuery.\n                    ")])]), _vm._v(" "), _c('tech-package', {
    attrs: {
      "type": "vue",
      "header": "vue-tinymce",
      "downloads": _vm.packages.vueTinymce.downloads,
      "stars": _vm.packages.vueTinymce.stars
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n                        TinyMCE wrapper for vue.js without jQuery. Plug and play style with translation support.\n                    ")])])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c7608ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/technology/pages/index.vue
// module id = 301
// module chunks = 1